<template>
  <section v-if="!visible" :class="`ryoma-services-archive--${$route.name}`">
    <ServiceWidget
      class="card-item"
      v-for="(service, index) in services"
      :key="index"
      :name="service.name"
      :excerpt="service.excerpt"
      :origami="getOrigami(service)"
      :class="getClass(service)"
      :id="getClass(service)"
      :slug="service.slug"
      @openService="openService"
    />
  </section>
  <router-view v-else></router-view>
</template>

<script>
import { mapGetters } from "vuex";
import { TimelineLite} from 'gsap'
// import {ScrollMagic} from 'vue-scrollmagic'

import ServiceWidget from "@/components/widgets/ServiceWidget.vue";

export default {
  name: "services-archives",
  watch: {
    $route(value) {
      this.visible = value.name === "service-details";
    }
  },
  data() {
    return {
      visible: false,
      imageTransition: null,
      currentService: null,
			controller: null,
      ia: null,
      frontEnd: null,
      lion: null,
      scene: null
    };
  },
  components: {
    ServiceWidget
  },
	mounted () {
    this.visible = this.$route.name === "service-details";

    // this.controller = new ScrollMagic.Controller();
    this.ia = new TimelineLite;
    this.frontEnd = new TimelineLite;
    this.lion = new TimelineLite;

    // Const for scroll card effect
    // const cardsContainer = document.querySelector('[class*=ryoma-services-archive]');

    const ia =  document.querySelector('#service-ia')
    const iceberg =  document.querySelector('#service-iceberg')
    const lion =  document.querySelector('#service-legal')

    const feTitle  = iceberg.querySelector('h3')
    const feExcerpt  = iceberg.querySelector('p')

    const leTitle  = lion.querySelector('h3')
    const leExcerpt  = lion.querySelector('p')

    this.frontEnd
      // .to(ia.querySelector('figure'), 2, {autoAlpha:0})
      .from(feTitle, .5, {
          y:200,
          autoAlpha: 0
        })
      .from(feExcerpt, .5, {
          autoAlpha: 0
        }, '-=.3')
      .to(iceberg, .25, { 
        y: -25
        })

    this.lion
      // .to(iceberg.querySelector('figure'), 2, {autoAlpha:0})
      .from(leTitle, 1, {
          y:200,
          autoAlpha: 0
        })
      .from(leExcerpt, .5, {
          autoAlpha: 0
        }, '-=.3')

		const scene2 = this.$scrollmagic.scene({
			// ID of element where animation starts
			triggerElement: ia,
		
			// {0,0.5,1} - animations starts from {top,center,end} of window
			triggerHook: 0.5,
		
			// Duration of animation
			duration: 1000
		})
		.setTween(this.ia)

		const scene3 = this.$scrollmagic.scene({
			// ID of element where animation starts
			triggerElement: iceberg,
		
			// {0,0.5,1} - animations starts from {top,center,end} of window
			triggerHook: 0.5,
		
			// Duration of animation
			duration: 300
		})
		.setTween(this.frontEnd)
			// Helpful tags for orientation on the screen
      // .addIndicators({ name: 'Iceberg (duration: 300)' })	

		const scene4 = this.$scrollmagic.scene({
			// ID of element where animation starts
			triggerElement: lion,
		
			// {0,0.5,1} - animations starts from {top,center,end} of window
			triggerHook: 0.5,
		
			// Duration of animation
			duration: 300
		})
		.setTween(this.lion)
			// Helpful tags for orientation on the screen
      // .addIndicators({ name: 'Lion (duration: 300)' })	

			// Add Scene to controller
			this.$scrollmagic.addScene(scene2)
			this.$scrollmagic.addScene(scene3)
			this.$scrollmagic.addScene(scene4)
	},
  computed: {
    ...mapGetters({
      services: "services"
    }),
    heroInfo: function() {
      return {
        title: this.$t("components.hero.services.title"),
        text: this.$t("components.hero.services.text")
      };
    }
  },
  methods: {
    getOrigami: function(service) {
      switch (service.ref) {
        case "ia":
          return "penguin";
        case "front":
          return "iceberg";
        case "accessibility":
          return "accessibility";
        case "ux":
          return "ux";
        case "banner":
          return "banner";
        case "legal":
          return "lion";

        default:
          return "https://via.placeholder.com/500x400";
      }
    },
    getClass: function(service) {
      switch (service.ref) {
        case "ia":
          return "ia";
        case "front":
          return "iceberg";
        case "ux":
          return "ux";
        case "banner":
          return "banner";
        case "legal":
          return "legal";

        default:
          return "transparent";
      }
    },
    goToService: function() {
      this.$router.push({
        name: "service-details",
        params: { slug: this.currentService }
      });
    },
    openService: function(event, slug) {
      this.$router.push({ name: "service-details", params: { slug: slug } });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_mixins.scss";

section {
  counter-reset: service; /* Set a counter named 'service', and its initial value is 0. */
  
  .card-item {
    @include respond-to(tablet) {
      position: relative; // fallback for browsers not supporting sticky position
      position: sticky;
      top: 0.75em;
      transform-origin: center top;
    }
  }
}
</style>


